import { faPencilAlt, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@vadiun/react-components';
import { useVerifyAction } from '@vadiun/react-hooks-legacy';
import { Table } from 'shared/components';
import { VehiculoFabricanteModel } from '../../fabricanteVehiculo/models/VehiculoFabricante';
import { VehiculoModeloModel } from '../models/VehiculoModelo';

interface Props {
  VehiculoModelos: VehiculoModeloModel[];
  selectToEdit: (x: VehiculoModeloModel) => void;
  delete: (x: VehiculoModeloModel) => void;
  restore: (x: VehiculoModeloModel) => void;
  handlePageChange: (currentPage: number) => void;
}

const VehiculoModeloTable = (props: Props) => {
  const verifyAction = useVerifyAction();

  const columns = [
    {
      name: 'nombre',
      label: 'Nombre',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: 'fabricante',
      label: 'Fabricante',
      options: {
        filter: false,
        customBodyRender: (fabricante: VehiculoFabricanteModel) => (
          <div style={{ display: 'flex' }}>{fabricante.nombre}</div>
        )
      }
    },
    {
      name: 'isDeleted',
      label: 'Borrado',
      options: {
        display: false,
        filterOptions: {
          names: ['Si', 'No']
        },
        filterList: ['No'],
        customFilterListOptions: { render: (v) => `Borrado: ${v}` }
      }
    },
    {
      label: 'Acciones',
      name: 'id',
      options: {
        filter: false,
        customBodyRenderLite: (index: number) =>
          props.VehiculoModelos[index].isDeleted ? (
            <Button onClick={() => props.restore(props.VehiculoModelos[index])}>
              Restaurar
            </Button>
          ) : (
            <div style={{ display: 'flex' }}>
              <Button
                onClick={() => props.selectToEdit(props.VehiculoModelos[index])}
                shape="circle"
                color="primary"
              >
                <FontAwesomeIcon icon={faPencilAlt} />
              </Button>
              <Button
                onClick={() =>
                  verifyAction({
                    title: 'Estas por eliminar un modelo!',
                    body: 'Esta accion va a eliminar el modelo. ¿Estas seguro?',
                    onAccept: () => props.delete(props.VehiculoModelos[index])
                  })
                }
                shape="circle"
                color="red"
              >
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            </div>
          )
      }
    }
  ];

  const data = props.VehiculoModelos.map((x) => ({
    ...x,
    isDeleted: x.isDeleted ? 'Si' : 'No'
  }));

  return (
    <div className="w-full">
      <Table
        options={{
          elevation: 0,
          selectableRows: 'none',
          onChangePage: props.handlePageChange,
        }}
        title={'Modelos'}
        data={data}
        columns={columns}
      />
    </div>
  );
};

export default VehiculoModeloTable;
